module.exports = __webpack_public_path__ + "static/about-background.f745cc72.png";


//////////////////
// WEBPACK FOOTER
// ./src/templates/assets/about-background.png
// module id = 982
// module chunks = 101932004231744